import { styled } from 'stitches.config'

export const DesktopMenuRoot = styled('div', {
  display: 'none',
  margin: '0 !important',

  '@bp2': {
    display: 'block',
    maxWidth: '280px',
    alignSelf: 'flex-start',
  },
})

export const MyAccountLink = styled('div', {
  backgroundColor: '$accent-white',
  padding: '12px $3',
  borderRadius: '$4',
  border: '1px solid $secondary-600',
  boxShadow: '0px 3px 0px $colors$secondary-600',

  variants: {
    active: {
      true: {
        backgroundColor: '$primary-800',
        color: '$accent-white',
        boxShadow: '0px 3px 0px $colors$quaternary-200',
        border: '1px solid $primary-800',
      },
    },
  },
})
